export interface IQuickMenuDataItem {
    name: string;
    value: number;
    icon: string;
    identifier: string;
    isAdded: boolean;
    show: boolean;
}

export class QuickMenuDataItem implements IQuickMenuDataItem {
    public name: string;
    public value: number;
    public icon: string;
    public identifier: string;
    public isAdded: boolean;
    public show: boolean;

    constructor();
    // tslint:disable-next-line: unified-signatures
    constructor(obj: IQuickMenuDataItem);
    constructor(obj?: any) {
        this.name = obj && obj.name || '';
        this.icon = obj && obj.icon || 'mdi-plus';
        this.value = obj && obj.value || 0;
        this.identifier = obj && obj.identifier || '';
        this.isAdded = obj && obj.isAdded || false;
        this.show = obj && obj.show || false;
    }
}
